/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { ICittaProductVideoViewProps } from './citta-product-video';

export default (props: ICittaProductVideoViewProps) => {
    return (
        <Module {...props.ProductVideoContainer} >
            { /* @ts-ignore */ }
            {props.player}
        </Module>
    );
};
